export const appUserAdmin = "APP_UserAdmin";
export const userInvoiceHistory = "Invoice History";
export const userInvoiceApprover = "Invoice Approver";
export const userInvoiceManager = "Invoice Manager";